module.exports = __webpack_public_path__ + "static/media/private dick 3.3a6eaecb.png";